export default class newsletterCtrl {
    constructor($scope, $http, $rootScope, $compile, $timeout, $interval) {
        'ngInject';

        $scope.validOptionNewsletter = {
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messages: {
                email: {
                    required: "We need your email address to contact you",
                    email: "Your email address must be in the format of name@domain.com"
                }
            },
            ignore: [],
            errorPlacement: function (error, element) {
                // var element = $(element).parent().parent().parent().parent().parent();
                error.insertAfter($(element).parent());
                
            },
            highlight: function (element, errorClass, validClass) {
                $(element)
                    .parent()
                    .addClass(errorClass)
                    .addClass('has-error');
            },
            unhighlight: function (element, errorClass, validClass) {
                if ($(element).is(":hidden")) {}
                $(element)
                    .parent()
                    .removeClass(errorClass)
                    .removeClass('has-error');
            }
        };
        $scope.newsletterForm = {};
        $scope.newsletter = {
            message: null,
            loading: false,
            status: false
        };
        $scope.frm = {};
        
        $scope.subscribeToNewsletter = function ($event, _action) {
            $scope.newsletter.message = '';
            if (!$scope.newsletterForm.validate()) {
                $scope.newsletter.loading = false;
                $event.preventDefault();
            } else {
                $scope.newsletter.loading = true;
                $scope.newsletter.message = '';
                $http({
                    method: "GET",
                    url: _action + '?email=' + $scope.frm.email,
                    data: {},
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    } // set the headers so angular passing info as form data (not request payload)
                }).then(function (response) {
                    var data = response.data;
                    $scope.newsletter.loading = false;
                    $scope.newsletter.status = data.status;
                    $scope.newsletter.message = data.message;
                }, function (response) {
                    var data = response.data;
                    $scope.newsletter.loading = false;
                });
            }
        }
        
        $scope.$watch("frm.email", function (newValue, oldValue) {
            $scope.newsletter.message = '';
        });
    }

}


// WEBPACK FOOTER //
// ./src/js/eshop/Controllers/12.newsletter.ctrl.js